import React, { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsServices from '../Services/SettingsServices';

export const FetchDataContext = createContext([])

function FetchData({ children }) {
    const [settings, setSettings] = useState({});
    const { i18n } = useTranslation();

    useEffect(() => {
        const timeOut = setTimeout(() => {
            SettingsServices(i18n.language).then(({ data }) => {
                if (data?.status === 200) {
                    setSettings(data?.data)
                }
            }).catch((error) => {
            });
        }, 200);
        return () => clearTimeout(timeOut);
    }, [i18n.language]);

    return (
        <FetchDataContext.Provider value={{ settings }}>
            {children}
        </FetchDataContext.Provider>
    )
}

export default FetchData